var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { homepageTracking } from "@irati-tracking/platform";
import Mobile from "./Mobile";
import Desktop from "./Desktop";
var HomepageTiles = /** @class */ (function (_super) {
    __extends(HomepageTiles, _super);
    function HomepageTiles() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.handleTileClick = function (tile) {
            var editMode = _this.props.editMode;
            var link = tile.link, openLinkInNewTab = tile.openLinkInNewTab;
            if (link && !editMode) {
                homepageTracking.clickTile(tile);
                if (openLinkInNewTab) {
                    window.open(link, "_blank");
                }
                else {
                    window.location.href = link;
                }
            }
        };
        return _this;
    }
    HomepageTiles.prototype.render = function () {
        var _a = this.props, isMobile = _a.isMobile, layout = _a.layout, widgets = _a.widgets, handleOnGridChange = _a.handleOnGridChange, editMode = _a.editMode, removeTileFromGrid = _a.removeTileFromGrid, editTile = _a.editTile, editingTileActive = _a.editingTileActive, tiles = _a.tiles;
        return (React.createElement(React.Fragment, null, isMobile
            ? React.createElement(Mobile, { tiles: tiles, onClick: this.handleTileClick })
            : React.createElement(Desktop, { layout: layout, widgets: widgets, handleOnGridChange: handleOnGridChange, removeTileFromGrid: removeTileFromGrid, editTile: editTile, onClick: this.handleTileClick, editingTileActive: editingTileActive, editMode: editMode })));
    };
    return HomepageTiles;
}(PureComponent));
export default HomepageTiles;
